import { Chip, Divider } from '@mui/material';
import Button from '@mui/material/Button';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavLink, withRouter } from 'react-router-dom';
import CustomScrollbars from 'util/CustomScrollbars';
import IntlMessages from 'util/IntlMessages';
import config from '../../config';
import { isRoleCheckList } from '../../util/utilFunction';



class SidenavContent extends Component {
  componentDidMount() {
    const {history} = this.props;
    const that = this;
    const pathname = `${history.location.pathname}`;// get current path

    const menuLi = document.getElementsByClassName('menu');

    for (let i = 0; i < menuLi.length; i++) {
      menuLi[i].onclick = function (event) {
        for (let j = 0; j < menuLi.length; j++) {
          const parentLi = that.closest(this, 'li');
          if (menuLi[j] !== this && (parentLi === null || !parentLi.classList.contains('open'))) {
            menuLi[j].classList.remove('open')
          }
        }
        this.classList.toggle('open');
      }
    }


    const activeLi = document.querySelector('a[href="' + pathname + '"]');// select current a element
    try {
      const activeNav = this.closest(activeLi, 'ul'); // select closest ul
      if (activeNav.classList.contains('sub-menu')) {
        this.closest(activeNav, 'li').classList.add('open');
      } else {
        this.closest(activeLi, 'li').classList.add('open');
      }
    } catch (error) {

    }


  }

  componentWillReceiveProps(nextProps) {

    const {history} = nextProps;
    const pathname = `${history.location.pathname}`;// get current path

    const activeLi = document.querySelector('a[href="' + pathname + '"]');// select current a element

   // console.log("activeLi ",activeLi)
    try {
      const activeNav = this.closest(activeLi, 'ul'); // select closest ul
      if (activeNav.classList.contains('sub-menu')) {
        this.closest(activeNav, 'li').classList.add('open');
      } else {
        this.closest(activeLi, 'li').classList.add('open');
      }
    } catch (error) {

    }
  }

  closest(el, selector) {
    try {
      let matchesFn;
      // find vendor prefix
      ['matches', 'webkitMatchesSelector', 'mozMatchesSelector', 'msMatchesSelector', 'oMatchesSelector'].some(function (fn) {
        if (typeof document.body[fn] == 'function') {
          matchesFn = fn;
          return true;
        }
        return false;
      });

      let parent;

      // traverse parents
      while (el) {
        parent = el.parentElement;
        if (parent && parent[matchesFn](selector)) {
          return parent;
        }
        el = parent;
      }
    } catch (e) {
 
    } 

    return null;
  }

  isRoleCheck = (roles,roleId)=>{
    return roles.find(x=> x.id===roleId) !== undefined
  }

  render() {
    const userRoles = this.props.authUser !== null ? this.props.authUser.userRoles : [];
    const coordinatorMenuStatus = this.props.authUser !== null ? isRoleCheckList(userRoles,[1,362,363,364]) : true ;
 
 const writerStatus = this.props.authUser !== null ?  isRoleCheckList(userRoles,[361,362,363,364]) : true ;
 // console.log("userRoles ",userRoles,writerStatus)
    return (
      <CustomScrollbars className="scrollbar">

{/* {
           userRoles.filter(x=>x.id>360 && x.id < 210).map((role,index)=><Chip   variant="outlined" size="small" key={"key"+role.id} label={role.name.split("-")[1]} className="m-1" color={index % 2 === 0 ? 'secondary' :'primary'} />)
          } */}
 <Divider light />

        <ul className="nav-menu">
    
    
          <li className="nav-header">
          <IntlMessages id="sidebar.main"/> 
          </li>
          <li className="menu no-arrow">
            <NavLink to="/says/mainPage">
              <i className="zmdi zmdi-view-dashboard zmdi-hc-fw"/>
              <span className="nav-text"> <IntlMessages id="sidebar.mainPage"/></span>
            </NavLink>
          </li>
        
          <li className="menu no-arrow">
            <NavLink to="/says/itemPrinciplesPage">
            <i className="zmdi zmdi-device-hub zmdi-hc-fw"/>
              <span className="nav-text"> <IntlMessages id="sidebar.itemPrinciples.1"/></span>
            </NavLink>
          </li>
          {/* <li className="menu no-arrow">
            <NavLink to="/says/itemPrinciplesPage">
            <i className="zmdi zmdi-device-hub zmdi-hc-fw"/>
              <span className="nav-text"> <IntlMessages id="sidebar.itemPrinciples.2"/></span>
            </NavLink>
          </li> */}
         { config.educationVideoVisible &&  !isRoleCheckList(userRoles,[1,361,362,363,364,365]) && <li className="menu no-arrow">
            <NavLink to="/says/educationPage">
            <i className="zmdi zmdi-comment-video zmdi-hc-fw"/>
              <span className="nav-text"> <IntlMessages id="sidebar.education"/></span>
            </NavLink>
          </li>}
          {isRoleCheckList(userRoles,[1,364]) &&
          <li className="menu no-arrow">
            <NavLink to="/says/projectManagementPage">
              <i className="zmdi zmdi-settings zmdi-hc-fw"/>
              <span className="nav-text"> Proje Yönetimi</span>
            </NavLink>
          </li>}   
 
          {isRoleCheckList(userRoles,[1,361,362,363,364]) &&
          <li className="menu no-arrow">
            <NavLink to="/says/searchUserProfile">
              <i className="zmdi zmdi-search zmdi-hc-fw"/>
              <span className="nav-text"> <IntlMessages id="absis.userSearch"/></span>
            </NavLink>
          </li>}
          <li className="menu no-arrow">
            <NavLink to="/says/faq">
            <i className="zmdi zmdi-pin-help zmdi-hc-fw"/>
              <span className="nav-text"> <IntlMessages id="sidebar.faq"/></span>
            </NavLink>
          </li>
          {isRoleCheckList(userRoles,[1,361,362,363,364]) &&
          <li className="menu no-arrow">
            <NavLink to="/says/searchItem">
              <i className="zmdi zmdi-search-in-file zmdi-hc-fw"/>
              <span className="nav-text"> <IntlMessages id="sidebar.searchItem"/></span>
            </NavLink>
          </li>}

                  {isRoleCheckList(userRoles,[1,363,364]) &&
                  <li className="menu no-arrow">
            <NavLink to="/says/statisticsPage">
              <i className="zmdi zmdi-chart zmdi-hc-fw"/>
              <span className="nav-text"> <IntlMessages id="sidebar.statisticsPage"/></span>
            </NavLink>
          </li>}
          {/* {isRoleCheckList(userRoles,[1,53,51,52]) &&
                  <li className="menu no-arrow">
            <NavLink to="/says/messageManagementPage">
              <i className="zmdi zmdi-email zmdi-hc-fw"/>
              <span className="nav-text"> Mesaj Yönetimi</span>
            </NavLink>
          </li>} */}
  {isRoleCheckList(userRoles,[1,362,364,365]) &&
                  <li className="menu no-arrow">
            <NavLink to="/says/translatePage">
              <i className="zmdi zmdi-translate zmdi-hc-fw"/>
              <span className="nav-text"> Madde Çeviri İşleri</span>
            </NavLink>
          </li>}
  {isRoleCheckList(userRoles,[1,365]) &&
                  <li className="menu no-arrow">
            <NavLink to="/says/translatorHistoryPage">
              <i className="zmdi zmdi-time-restore zmdi-hc-fw"/>
              <span className="nav-text"> Geçmiş Çevirilerim</span>
            </NavLink>
          </li>}
          {isRoleCheckList(userRoles,[1,362,364,366]) &&
                  <li className="menu no-arrow">
            <NavLink to="/says/proofreaderPage">
              <i className="zmdi zmdi-format-indent-increase zmdi-hc-fw"/>
              <span className="nav-text"> Madde Tashih İşleri</span>
            </NavLink>
          </li>}
          {isRoleCheckList(userRoles,[1,361,362,363,364]) &&
                  <li className="menu no-arrow">
            <NavLink to="/says/proofreaderManagementPage">
              <i className="zmdi zmdi-assignment-check zmdi-hc-fw"/>
              <span className="nav-text"> Madde Tashih Yönetimi</span>
            </NavLink>
          </li>}
          {isRoleCheckList(userRoles,[1,367]) &&
                  <li className="menu no-arrow">
            <NavLink to="/says/paymentPage">
              <i className="zmdi zmdi-money zmdi-hc-fw"/>
              <span className="nav-text"> Ödeme İşleri</span>
            </NavLink>
          </li>}

         {isRoleCheckList(userRoles,[367]) && <li className="menu no-arrow "  key="cess2">
            <NavLink to="/says/inInstitutions">
              <i className="zmdi zmdi-home zmdi-hc-fw"/>
              <span className="nav-text"> <IntlMessages id="sidebar.inInstitutions"/></span>
            </NavLink>
          </li>}



          {/* {isRoleCheckList(userRoles,[1,362,364,366,367]) &&
                  <li className="menu no-arrow">
            <NavLink to="/says/editorPage">
              <i className="zmdi zmdi-format-indent-increase zmdi-hc-fw"/>
              <span className="nav-text"> Madde Editör İşleri</span>
            </NavLink>
          </li>} */}
          { writerStatus && 
  <li className="menu collapse-box" id="writerMenu"> 
  <Button>
      <i className="zmdi zmdi-book zmdi-hc-fw"/>
      <span className="nav-text">
     <IntlMessages id="sidebar.wirterRefereeProcess.ex"/>  
      
      </span>
    </Button>
    <ul className="sub-menu" id="writerSubMenu">
             <li>
            <NavLink to="/says/myProfile">
              <i className="zmdi zmdi-account-calendar zmdi-hc-fw"/>
              <span className="nav-text"> <IntlMessages id="absis.myProfile"/></span>
            </NavLink>
          </li> 
       
          <li>
            <NavLink to="/says/sendItemPage">
              <i className="zmdi zmdi-book zmdi-hc-fw"/>
              <span className="nav-text"> <IntlMessages id="sidebar.sendItem"/></span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/says/adviceItemPage">
              <i className="zmdi zmdi-book zmdi-hc-fw"/>
              <span className="nav-text"> <IntlMessages id="sidebar.adviceItem"/></span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/says/myItemsPage">
              <i className="zmdi zmdi-book zmdi-hc-fw"/>
              <span className="nav-text"> <IntlMessages id="sidebar.myItems"/></span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/says/myRefereePage">
              <i className="zmdi zmdi-rss zmdi-hc-fw"/>
              <span className="nav-text"> <IntlMessages id="sidebar.myReferee"/></span>
            </NavLink>
          </li>
      </ul>
      </li>
  }

   
      
{ 
  isRoleCheckList(userRoles,[361,362,363,364]) ?  null :
          [<li className="nav-header" key="wrp1">
          <IntlMessages id="sidebar.wirterRefereeProcess"/> 
          </li>,
              <li className="menu no-arrow" key="wrp2">
              <NavLink to="/says/myProfile">
                <i className="zmdi zmdi-account-calendar zmdi-hc-fw"/>
                <span className="nav-text"> <IntlMessages id="absis.myProfile"/></span>
              </NavLink>
            </li>,         
              <li className="menu no-arrow" key="wrp4222">
              <NavLink to="/says/adviceItemPage">
                <i className="zmdi zmdi-book zmdi-hc-fw"/>
                <span className="nav-text"> <IntlMessages id="sidebar.adviceItem"/></span>
              </NavLink>
            </li>,
            <li className="menu no-arrow" key="wrp4">
              <NavLink to="/says/sendItemPage">
                <i className="zmdi zmdi-book zmdi-hc-fw"/>
                <span className="nav-text"> <IntlMessages id="sidebar.sendItem"/></span>
              </NavLink>
            </li>,
         
          <li className="menu no-arrow" key="wrp6">
            <NavLink to="/says/myItemsPage">
              <i className="zmdi zmdi-book zmdi-hc-fw"/>
              <span className="nav-text"> <IntlMessages id="sidebar.myItems"/></span>
            </NavLink>
          </li>,
          <li className="menu no-arrow" key="wrp7">
            <NavLink to="/says/myRefereePage">
              <i className="zmdi zmdi-rss zmdi-hc-fw"/>
              <span className="nav-text"> <IntlMessages id="sidebar.myReferee"/></span>
            </NavLink>
          </li>]
      
} 

{
  isRoleCheckList(userRoles,[361,362,363,364]) && 
[  <li className="nav-header" key="c1dsds">
          <IntlMessages id="sidebar.coordinatorAndEditor"/> 
          </li>,
             
             this.isRoleCheck(userRoles,361) && <li className="menu no-arrow "  key="ce1">
             <NavLink to="/says/inProgressPage">
               <i className="zmdi zmdi-spinner zmdi-hc-fw"/>
               <span className="nav-text"> <IntlMessages id="sidebar.inProgress"/></span>
             </NavLink>
           </li>,
            <li className="menu no-arrow "  key="ce2">
            <NavLink to="/says/inInstitutions">
              <i className="zmdi zmdi-home zmdi-hc-fw"/>
              <span className="nav-text"> <IntlMessages id="sidebar.inInstitutions"/></span>
            </NavLink>
          </li>,
             
   isRoleCheckList(userRoles,[362,361]) &&   <li>
   <NavLink to="/says/invitedWriter">
     <i className="zmdi zmdi-email zmdi-hc-fw"/>
     <span className="nav-text"> Yazara Davet</span>
   </NavLink>
 </li>,
           
               <li className="menu no-arrow "  key="ce23dd5">
               <NavLink to="/says/suggestItemPage">
                 <i className="zmdi zmdi-book zmdi-hc-fw"/>
                 <span className="nav-text"> Önerilen Maddeler</span>
               </NavLink>
             </li>,
           <li className="menu no-arrow "  key="ce4">
           <NavLink to="/says/ItemPoolPage">
             <i className="zmdi zmdi-fullscreen zmdi-hc-fw"/>
             <span className="nav-text"> Madde Havuzu</span>
           </NavLink>
         </li>,
          <li className="menu no-arrow "  key="ce3">
          <NavLink to="/says/ComplatedPage">
            <i className="zmdi zmdi-check zmdi-hc-fw"/>
            <span className="nav-text"> <IntlMessages id="sidebar.ComplatedPage"/></span>
          </NavLink>
        </li>,
          isRoleCheckList(userRoles,[1,361,362]) && <li className="menu no-arrow "  key="ce3-1">
          <NavLink to="/says/contentSearchPage">
            <i className="zmdi zmdi-search-in-file zmdi-hc-fw"/>
            <span className="nav-text"> İçerikte Arama</span>
          </NavLink>
        </li>,
          this.isRoleCheck(userRoles,362) && <li>
          <NavLink to="/says/itemCommisionPage">
            <i className="zmdi zmdi-settings zmdi-hc-fw"/>
            <span className="nav-text">Komisyon Sayfası </span>
          </NavLink>
        </li>,
             <li className="menu no-arrow "  key="ce235">
             <NavLink to="/says/itemsMapPage">
               <i className="zmdi zmdi-map zmdi-hc-fw"/>
               <span className="nav-text"> Madde Haritası</span>
             </NavLink>
           </li>,
           <li className="menu no-arrow "  key="ce5">
           <NavLink to="/says/PublicationPage">
             <i className="zmdi zmdi-rss zmdi-hc-fw"/>
             <span className="nav-text"> Yayındakiler</span>
           </NavLink>
         </li>,
        <li className="menu no-arrow "  key="ce6">
        <NavLink to="/says/sendItemWriterPage">
          <i className="zmdi zmdi-edit zmdi-hc-fw"/>
          <span className="nav-text"> Kurum Adına Giriş</span>
        </NavLink>
      </li>,
      this.isRoleCheck(userRoles,362) && <li  key="c10">
      <NavLink to="/says/assignedItemPage">
        <i className="zmdi zmdi-assignment-account zmdi-hc-fw"/>
        <span className="nav-text"> <IntlMessages id="sidebar.assignedItem"/></span>
      </NavLink>
    </li>,this.isRoleCheck(userRoles,362) &&   <li>
<NavLink to="/says/beforeAssignedItemPage">
 <i className="zmdi zmdi-assignment-check zmdi-hc-fw"/>
 <span className="nav-text"> <IntlMessages id="sidebar.beforeAssignedItem"/></span>
</NavLink>
</li>,

                       <li  className="menu no-arrow "  key="ce7">
                      <NavLink to="/says/ItemIndexPage"> 
                        <i className="zmdi zmdi-sort zmdi-hc-fw"/>
                        <span className="nav-text"> Madde İndex</span>
                      </NavLink>
                    </li> 
                 ,
                    <li  className="menu no-arrow "  key="ce8">
                      <NavLink to="/says/WriterIndexPage">
                        <i className="zmdi zmdi-accounts zmdi-hc-fw"/>
                        <span className="nav-text"> Yazar İndex</span>
                      </NavLink>
                    </li>,
 

      isRoleCheckList(userRoles,[1,363,362]) &&  <li >
  <NavLink to="/says/roleManagementPage">
      <i className="zmdi zmdi-account zmdi-hc-fw"/>
      <span className="nav-text"><IntlMessages id="sidebar.roleManagement"/> </span>
    </NavLink>
  </li>,


    
   this.isRoleCheck(userRoles,362) &&   <li>
      <NavLink to="/says/settings">
        <i className="zmdi zmdi-settings zmdi-hc-fw"/>
        <span className="nav-text"> Ayarlar</span>
      </NavLink>
    </li>,
    this.isRoleCheck(userRoles, 1) && <li className="menu no-arrow" key="logsApi">
      <NavLink to="/says/logsApiPage">
        <i className="zmdi zmdi-time-restore zmdi-hc-fw"/>
        <span className="nav-text"> API İşlem Kayıtları</span>
      </NavLink>
    </li>


        ]
}




        </ul>
      </CustomScrollbars>
    );
  }
}


const mapStateToProps = ({auth,settings}) => {
  const {authUser} = auth;
  const {locale} = settings;
  return {authUser,locale};
};

export default withRouter(connect(mapStateToProps)(SidenavContent));


